













import iconToggleButton from '../elements/IconToggleButton.vue'

export default {
  name: 'ToggableOptionList'

  components: 
    'v-icon-toggle-button': iconToggleButton

  data: () ->
    show: false

  props: [
    'id'
    'label'
    'options'
  ]

}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/ToggableOptionList.vue